import { HASHTAGS } from "../type/EnumHashtags";

export const getHashtags = () => Object.values(HASHTAGS);